import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import SubscriptionModal from '../components/SubscriptionModal';
import SafeIcon from '../common/SafeIcon';
import { useStore } from '../context/StoreContext';

const Live = () => {
  const [isSubModalOpen, setSubModalOpen] = useState(false);
  const [chatMsg, setChatMsg] = useState('');
  const { liveSettings, user } = useStore();

  const handleSendChat = (e) => {
    e.preventDefault();
    if (!user.isSubscribed) {
      setSubModalOpen(true);
      return;
    }
    setChatMsg('');
  };

  return (
    <div className="min-h-screen bg-dark-bg flex flex-col">
      <Navbar onOpenSub={() => setSubModalOpen(true)} />
      
      <div className="flex-1 pt-24 container mx-auto px-4 md:px-6 pb-8 flex flex-col lg:flex-row gap-6">
        
        {/* Main Player Area */}
        <div className="flex-1 flex flex-col">
          <div className="flex items-center space-x-3 mb-4">
            <div className="bg-danger text-white text-xs font-bold px-3 py-1 rounded flex items-center shadow-[0_0_10px_rgba(255,45,45,0.5)]">
              <span className="w-2 h-2 bg-white rounded-full mr-2 animate-pulse"></span>
              LIVE
            </div>
            <h1 className="text-2xl md:text-3xl font-bold">{liveSettings.title}</h1>
          </div>

          <div className="w-full aspect-video bg-black rounded-xl overflow-hidden border border-dark-border shadow-2xl relative">
            {liveSettings.isLive && liveSettings.embedHtml ? (
              <div 
                className="w-full h-full"
                dangerouslySetInnerHTML={{ __html: liveSettings.embedHtml }} 
              />
            ) : (
              <div className="absolute inset-0 flex flex-col items-center justify-center bg-dark-surface p-8 text-center">
                <SafeIcon name="Radio" className="w-16 h-16 text-muted mb-4" />
                <h2 className="text-2xl font-bold mb-2">Stream Offline</h2>
                <p className="text-muted mb-6">Next live stream is scheduled for: <br/>
                  <strong className="text-white text-lg">{new Date(liveSettings.nextLiveAt).toLocaleString()}</strong>
                </p>
                <p className="text-sm text-muted max-w-md">{liveSettings.description}</p>
              </div>
            )}
          </div>
          
          <div className="mt-6 bg-dark-surface border border-dark-border p-6 rounded-xl">
            <h3 className="text-lg font-bold mb-2">About this session</h3>
            <p className="text-muted">{liveSettings.description}</p>
          </div>
        </div>

        {/* Chat Sidebar */}
        <div className="w-full lg:w-80 lg:flex-shrink-0 bg-dark-surface border border-dark-border rounded-xl flex flex-col h-[500px] lg:h-auto">
          <div className="p-4 border-b border-dark-border flex justify-between items-center">
            <h3 className="font-bold flex items-center"><SafeIcon name="MessageSquare" className="w-4 h-4 mr-2" /> Live Chat</h3>
            <span className="text-xs text-muted">1.2k watching</span>
          </div>
          
          <div className="flex-1 overflow-y-auto p-4 space-y-4">
            {/* Mock chat messages */}
            <div className="text-sm"><span className="text-rocket font-bold">TraderJoe:</span> Setup looking perfect here.</div>
            <div className="text-sm"><span className="text-blue-400 font-bold">AlphaSeeker:</span> Did he mention the entry price?</div>
            <div className="text-sm"><span className="text-green-400 font-bold">OptionsKing:</span> Secured 20% on that scalp! 🚀</div>
          </div>

          <div className="p-4 border-t border-dark-border bg-dark-bg rounded-b-xl relative">
            {!user.isSubscribed && (
              <div className="absolute inset-0 bg-dark-surface/80 backdrop-blur-sm flex flex-col items-center justify-center rounded-b-xl z-10">
                <SafeIcon name="Lock" className="w-6 h-6 text-muted mb-2" />
                <p className="text-sm text-center px-4 mb-2">Subscribers only chat</p>
                <button onClick={() => setSubModalOpen(true)} className="text-xs bg-rocket text-white px-3 py-1.5 rounded">Unlock Access</button>
              </div>
            )}
            <form onSubmit={handleSendChat} className="flex">
              <input 
                type="text" 
                value={chatMsg}
                onChange={(e) => setChatMsg(e.target.value)}
                placeholder="Chat openly..." 
                className="flex-1 bg-dark-card border border-dark-border rounded-l-md px-3 py-2 text-sm focus:outline-none focus:border-rocket"
              />
              <button type="submit" className="bg-dark-card border border-l-0 border-dark-border rounded-r-md px-3 hover:text-rocket transition-colors">
                <SafeIcon name="Send" className="w-4 h-4" />
              </button>
            </form>
          </div>
        </div>

      </div>

      <SubscriptionModal isOpen={isSubModalOpen} onClose={() => setSubModalOpen(false)} />
    </div>
  );
};

export default Live;